import IconWarning from "@iconsV2/Warnings/information-circle.svg?react";

import Caption from "../Caption";
import Paragraph from "../Paragraph";
import {
  StyledWrapperBestSeller,
  StyledWrapperBlackDiscount,
  StyledWrapperPrimatonDiscount,
  StyledWrapperComingSoon,
  StyledWrapperCustomLabel,
  StyledWrapperDiscount,
  StyledWrapperExclusiveDiscount,
  StyledWrapperIsPromoted,
  StyledWrapperNew,
} from "./styles";
import Tooltip, { TooltipContent, TooltipTrigger } from "@/components/Atoms/Tooltip";
import IconTagUnion from "@iconsV2/Illustration/tagUnion.svg?react";
import { TYPE_DISCOUNT } from "@/services/checkout/type";

interface IProductCardTagDiscountProps {
  type: "discount";
  amount: string;
}

interface IProductCardTagCustomLabelProps {
  type: "customLabel";
  /** Badge text (`discount.label`) */
  label: string;
  /** Discount type (`TYPE_DISCOUNT`), defines the badge style */
  discountType?: string;
  labelBackground?: string;
}

interface IProductCardTagProps {
  type: "new" | "promoted" | "bestSeller" | "comingSoon" | "exclusiveDiscount";
}

type TProductCardTagProps = (
  | IProductCardTagDiscountProps
  | IProductCardTagCustomLabelProps
  | IProductCardTagProps
) &
  Record<string, any>;

const ProductCardTag = ({ type, ...props }: TProductCardTagProps) => {
  const has_black_discount = props.discountType === TYPE_DISCOUNT.BLACK_SALE;
  const has_primaton = props.discountType === TYPE_DISCOUNT.PRIMATON;
  if (!type) {
    throw new TypeError("Type is required");
  }
  if (type === "comingSoon") {
    return (
      <StyledWrapperComingSoon {...props}>
        <Paragraph sizeVariant="sm" color="white" fontWeight="700">
          Próximamente
        </Paragraph>

        <IconTagUnion />
      </StyledWrapperComingSoon>
    );
  }

  if (type === "new") {
    return (
      <StyledWrapperNew {...props}>
        <Paragraph sizeVariant="sm" color="white" fontWeight="700">
          Nuevo
        </Paragraph>

        <IconTagUnion />
      </StyledWrapperNew>
    );
  }
  if (type === "discount") {
    return (
      <StyledWrapperDiscount {...props}>
        <Paragraph sizeVariant="sm" color="white" fontWeight="700">
          {(props as IProductCardTagDiscountProps).amount}%
        </Paragraph>

        <IconTagUnion />
      </StyledWrapperDiscount>
    );
  }

  if (type === "promoted") {
    return (
      <StyledWrapperIsPromoted {...props}>
        <Caption>Promocionado</Caption>
      </StyledWrapperIsPromoted>
    );
  }

  if (type === "bestSeller") {
    return (
      <StyledWrapperBestSeller {...props}>
        <Paragraph sizeVariant="sm" fontWeight="700" color="white">
          Más vendido
        </Paragraph>
      </StyledWrapperBestSeller>
    );
  }
  if (type === "customLabel") {
    const { labelBackground, label, discountType, ...rest } = props as IProductCardTagCustomLabelProps;
    const isKnownDiscount = Object.values<string>(TYPE_DISCOUNT).includes(discountType ?? "");

    if (has_black_discount) {
      return (
        <StyledWrapperBlackDiscount>
          <Paragraph sizeVariant="sm" fontWeight="700" color="inherit">
            {label}
          </Paragraph>
        </StyledWrapperBlackDiscount>
      );
    }

    if (has_primaton) {
      return (
        <StyledWrapperPrimatonDiscount>
          <Paragraph sizeVariant="sm" fontWeight="700" color="inherit">
            {label}
          </Paragraph>
        </StyledWrapperPrimatonDiscount>
      );
    }
    if (isKnownDiscount && discountType !== TYPE_DISCOUNT.EXPIRATION_DISCOUNT) {
      return (
        <StyledWrapperExclusiveDiscount {...rest}>
          <Paragraph sizeVariant="sm" fontWeight="700" color="inherit">
            {label}
          </Paragraph>
        </StyledWrapperExclusiveDiscount>
      );
    }

    return (
      <Tooltip placement="bottom-end">
        <TooltipTrigger>
          <StyledWrapperCustomLabel {...rest} $bg={labelBackground} $label={label}>
            <Paragraph sizeVariant="sm" fontWeight="700" color="inherit">
              {label}
            </Paragraph>

            <IconWarning />
          </StyledWrapperCustomLabel>
        </TooltipTrigger>
        <TooltipContent tw="max-w-[14.313rem] z-1">
          <Paragraph sizeVariant="sm">Producto en excelente estado, con pronta vida útil.</Paragraph>
        </TooltipContent>
      </Tooltip>
    );
  }
};

export default ProductCardTag;
